import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10972f56"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "largeim",
  style: {"width":"100%","height":"100%"}
}, [
  /*#__PURE__*/_createElementVNode("img", { src: "/statics/images/test/kj.jpg" })
], -1))
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "section-div" }
const _hoisted_4 = { class: "section-p1" }
const _hoisted_5 = { class: "section-p1-div1" }
const _hoisted_6 = { class: "section-p2" }
const _hoisted_7 = { src: "/statics/images/test/test5.jpg" }
const _hoisted_8 = { src: "/statics/images/test/test21.jpg" }
const _hoisted_9 = { class: "row section-p3" }
const _hoisted_10 = { class: "box" }
const _hoisted_11 = { class: "da" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "section-div-div-p1" }
const _hoisted_15 = { class: "section-div-div-p2" }
const _hoisted_16 = { class: "row section-div-div-p3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heng" }, null, -1))
const _hoisted_18 = { class: "zi" }
const _hoisted_19 = { class: "section2" }
const _hoisted_20 = { class: "section-div" }
const _hoisted_21 = { class: "section2-p1" }
const _hoisted_22 = { class: "section2-p1-div1" }
const _hoisted_23 = { class: "section2-p2" }
const _hoisted_24 = { src: "/statics/images/test/test9.jpg" }
const _hoisted_25 = { src: "/statics/images/test/test22.jpg" }
const _hoisted_26 = { class: "row section2-p3" }
const _hoisted_27 = { class: "box" }
const _hoisted_28 = { class: "da" }
const _hoisted_29 = ["src"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "section-div-div-p1" }
const _hoisted_32 = { class: "section-div-div-p2" }
const _hoisted_33 = { class: "row section-div-div-p3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heng" }, null, -1))
const _hoisted_35 = { class: "zi" }
const _hoisted_36 = { class: "section" }
const _hoisted_37 = { class: "section-div" }
const _hoisted_38 = { class: "section-p1" }
const _hoisted_39 = { class: "section-p1-div1" }
const _hoisted_40 = { class: "section-p2" }
const _hoisted_41 = { src: "/statics/images/test/test15.jpg" }
const _hoisted_42 = { src: "/statics/images/test/test23.jpg" }
const _hoisted_43 = { class: "row section-p3" }
const _hoisted_44 = { class: "box" }
const _hoisted_45 = { class: "da" }
const _hoisted_46 = ["src"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "section-div-div-p1" }
const _hoisted_49 = { class: "section-div-div-p2" }
const _hoisted_50 = { class: "row section-div-div-p3" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heng" }, null, -1))
const _hoisted_52 = { class: "zi" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.show ? "吸收性卫生用品" : "Absorbent Hygiene Products"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
            [_vShow, _ctx.show]
          ]),
          _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
            [_vShow, !_ctx.show]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.absorbData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-4",
              key: index
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("img", {
                    src: 
                  _ctx.url +
                  '/' +
                  item.pictureAttachment.filePath +
                  '/' +
                  item.pictureAttachment.id +
                  item.pictureAttachment.suffix
                
                  }, null, 8, _hoisted_12)
                ]),
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.golink(1, item.id, item.fkCategoryId.name, item.title))
                }, [
                  _createElementVNode("p", _hoisted_14, _toDisplayString(item.title), 1),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(item.summary), 1),
                  _createElementVNode("p", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.show ? "了解更多" : "MORE"), 1)
                  ])
                ], 8, _hoisted_13)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", null, _toDisplayString(_ctx.show ? "皮肤护理" : "Skin Care"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _withDirectives(_createElementVNode("img", _hoisted_24, null, 512), [
            [_vShow, _ctx.show]
          ]),
          _withDirectives(_createElementVNode("img", _hoisted_25, null, 512), [
            [_vShow, !_ctx.show]
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skinCareData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-4",
              key: index
            }, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("img", {
                    src: 
                  _ctx.url +
                  '/' +
                  item.pictureAttachment.filePath +
                  '/' +
                  item.pictureAttachment.id +
                  item.pictureAttachment.suffix
                
                  }, null, 8, _hoisted_29)
                ]),
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.golink(2, item.id, item.fkCategoryId.name, item.title))
                }, [
                  _createElementVNode("p", _hoisted_31, _toDisplayString(item.title), 1),
                  _createElementVNode("p", _hoisted_32, _toDisplayString(item.summary), 1),
                  _createElementVNode("p", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.show ? "了解更多" : "MORE"), 1)
                  ])
                ], 8, _hoisted_30)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("span", null, _toDisplayString(_ctx.show ? "国际认证&国际法规动态" : "Certification & Regulations News"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _withDirectives(_createElementVNode("img", _hoisted_41, null, 512), [
            [_vShow, _ctx.show]
          ]),
          _withDirectives(_createElementVNode("img", _hoisted_42, null, 512), [
            [_vShow, !_ctx.show]
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.InternationalData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-4",
              key: index
            }, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("img", {
                    src: 
                  _ctx.url +
                  '/' +
                  item.pictureAttachment.filePath +
                  '/' +
                  item.pictureAttachment.id +
                  item.pictureAttachment.suffix
                
                  }, null, 8, _hoisted_46)
                ]),
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.golink(3, item.id, item.fkCategoryId.name, item.title))
                }, [
                  _createElementVNode("p", _hoisted_48, _toDisplayString(item.title), 1),
                  _createElementVNode("p", _hoisted_49, _toDisplayString(item.summary), 1),
                  _createElementVNode("p", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.show ? "了解更多" : "MORE"), 1)
                  ])
                ], 8, _hoisted_47)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}